import {apolloClient} from '@/setup/apollo-setup';
import {error, updateItemSuccess } from '@/utils/notification';
import {
  GET_ACADEMICPERIODCONFIGS,
  GET_ACADEMICPERIODCONFIGS_CURRENT,
  GET_ACADEMICPERIODCONFIG,
  UPDATE_ACADEMICPERIODCONFIG,
} from '@/queries/modules/common-data/academicPeriodConfig';

export async function getAcademicPeriodConfigs(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ACADEMICPERIODCONFIGS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setAcademicPeriodConfigs', data.getAcademicPeriodConfigs);
      context.commit('setSuccess', null);
      return data.getAcademicPeriodConfigs
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getAcademicPeriodConfig(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ACADEMICPERIODCONFIG,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setAcademicPeriodConfig', data.getAcademicPeriodConfig);
      context.commit('setSuccess', null);
      return data.getAcademicPeriodConfig
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getCurrentAcademicPeriodConfig(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ACADEMICPERIODCONFIGS_CURRENT,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;
    if (errors) {
      context.commit('setError', error(errors));
      return null
    } else {
      context.commit('setAcademicPeriodConfig', data.getCurrentAcademicPeriodConfig);
      context.commit('setSuccess', null);
      return data.getCurrentAcademicPeriodConfig
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null
  }
}

export async function updateAcademicPeriodConfig(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_ACADEMICPERIODCONFIG,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.academicPeriodConfigs.findIndex(item => item.id === data.updateAcademicPeriodConfig.id);
      const academicPeriodConfigs = [
        ...context.state.academicPeriodConfigs.slice(0, index),
        data.updateAcademicPeriodConfig,
        ...context.state.academicPeriodConfigs.slice(index + 1)
      ];
      context.commit('setAcademicPeriodConfigs', academicPeriodConfigs);
      context.commit('setSuccess', updateItemSuccess(data.updateAcademicPeriodConfig.learnPeriodCode));

      return data.updateAcademicPeriodConfig
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
